import { Theme } from '@mui/material/styles';
import { Margin } from 'recharts/types/util/types';

export function getChartTypography(theme: Theme) {
  const axisFontSize = 12;
  const fontFamily = theme.typography.fontFamily;
  const h3 = theme.typography['h3'];
  const subtitle1 = theme.typography['subtitle1'];
  const titleFontFamily = h3.fontFamily;
  const titleFontSize = Number(h3.fontSize);
  const subtitleFontFamily = subtitle1.fontFamily;
  const subtitleFontSize = Number(subtitle1.fontSize);

  return {
    axisFontSize,
    fontFamily,
    titleFontFamily,
    titleFontSize,
    subtitleFontFamily,
    subtitleFontSize,
  };
}

export function computeChartMargins(opts: {
  titleFontSize: number;
  subtitleFontSize: number;
  showLegend?: boolean;
  yTitle?: string;
  xTitle?: string;
  rotateXTicks?: boolean;
}) {
  const {
    titleFontSize,
    subtitleFontSize,
    showLegend,
    yTitle,
    xTitle,
    rotateXTicks,
  } = opts;
  // Adding + 4 on each element for extra separation
  const top =
    0 +
    // Account for each element height
    (titleFontSize ? titleFontSize + 20 + 4 : 0) +
    (subtitleFontSize ? subtitleFontSize + 10 + 4 : 0) +
    (showLegend ? 13 + 4 : 0) +
    // If no element is displayed, allow chart to occupy all the height
    (!titleFontSize && !subtitleFontSize && !showLegend ? 0 : 20);
  const legendTop =
    6 +
    (titleFontSize ? titleFontSize + 20 + 4 : 0) +
    (subtitleFontSize ? subtitleFontSize + 10 + 4 : 0);
  const right = 8;
  const left = yTitle ? (rotateXTicks ? 38 : 16) : 0;
  const bottom = xTitle ? 22 : 0;

  return { margin: { top, right, left, bottom } as Margin, legendTop };
}
